module.exports = __webpack_public_path__ + "static/media/profile.af878d33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Update/profile.jpg
// module id = 318
// module chunks = 0